import { Navigate } from "react-router";
import { useAdminAuth } from "../../utils/useAuth";

const AdminPublicRoute = ({ children }) => {
  const { isAdmin } = useAdminAuth();

  if (isAdmin) {
    return <Navigate to={"/admin/dashboard"} replace />;
  }
  return children;
};

export default AdminPublicRoute;
